export default __webpack_public_path__ + "static/resume-3a5a83cd95fa3d425a693328821355cd.pdf";